import { render, staticRenderFns } from "./ProfileInfo.vue?vue&type=template&id=7ad22e29&"
import script from "./ProfileInfo.vue?vue&type=script&lang=js&"
export * from "./ProfileInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ad22e29')) {
      api.createRecord('7ad22e29', component.options)
    } else {
      api.reload('7ad22e29', component.options)
    }
    module.hot.accept("./ProfileInfo.vue?vue&type=template&id=7ad22e29&", function () {
      api.rerender('7ad22e29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/customers/ProfileInfo.vue"
export default component.exports